import React, { useState } from 'react';
import { Link } from '__models__/models';
import Icon, { Size } from 'components/general/icon/icon';
import LabelWithStarIcon from 'components/talentUser/LabelWithStarIcon';
import Button from 'lj_shared/button/button';
import Tooltip from 'components/general/tooltip/tooltip';

const styles = require('./links.module.scss');
interface Props {
  disabled?: boolean;
  headerKey?: string;
  links: Link[];
  ljColor?: string;
  handshakeProfile?: boolean;
  openModal?: (headerKey: string, arg: any, selector: string) => void;
}

const Links = ({ headerKey, links, ljColor, disabled, handshakeProfile, openModal }: Props) => {
  const [isSyncing, setIsSyncing] = useState(false);

  if (!links && links === undefined) {
    return null;
  }

  const handleLinkedInSync = () => {
    setIsSyncing(true);
    // Create and submit a form to trigger the sync
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = '/users/linkedin_sync';
    
    // Add CSRF token
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
    if (csrfToken) {
      const csrfInput = document.createElement('input');
      csrfInput.type = 'hidden';
      csrfInput.name = 'authenticity_token';
      csrfInput.value = csrfToken;
      form.appendChild(csrfInput);
    }
    
    document.body.appendChild(form);
    form.submit();
  };

  if (disabled) {
    return (
      <div className={styles.blur}>
        {links.map((link: Link) => {
          return (
            <Icon
              key={link.title.toLowerCase()}
              name={link.category_key !== 'other' ? link.category_key : 'link'}
              color={ljColor || 'flamingo'}
              size={link.category_key === 'twitter' ? Size.QuiteSmall : Size.Medium}
            />
          );
        })}
      </div>
    );
  }

  function renderNoLink(label) {
    return <LabelWithStarIcon label={label} value={false} styles={styles.noLink} />;
  }

  function renderCvButton() {
    return (
      <Button
        onClick={() => openModal(headerKey, null, '#cvFileName')}
        buttonColor='tuftsBlue'
        buttonSize='tiny'
        isRound
      >
        Add a CV
      </Button>
    );
  }

  function checkIfHasLink(category) {
    return links.some(item => item.category_key === category);
  }

  const hasLinkedIn = checkIfHasLink('linkedin');
  const tooltipText = hasLinkedIn
    ? 'Update your profile with the latest information from your LinkedIn account'
    : "You'll need to connect LinkedIn first. Look for the pencil icon to set this up";

  return (
    <>
      {links.map((link: Link) => (
        <a
          key={link.category_key}
          href={link.url}
          target='_blank'
          rel='noopener noreferrer'
          className={styles.linkItem}
        >
          <Icon
            key={link.title.toLowerCase()}
            name={link.category_key !== 'other' ? link.category_key : 'link'}
            color={ljColor || 'flamingo'}
            size={link.category_key === 'twitter' ? Size.QuiteSmall : Size.Medium}

          />
        </a>
      ))}
      {!handshakeProfile && !checkIfHasLink('cv') && renderCvButton()}
      {!handshakeProfile && (
        <Tooltip
          text={tooltipText}
          textBelow={true}
          className={styles.syncButtonWrapper}
        >
          <Button
            onClick={handleLinkedInSync}
            buttonColor={hasLinkedIn ? 'tuftsBlue' : 'silverSand'}
            buttonSize='tiny'
            isRound
            isButton={true}
            disabled={isSyncing || !hasLinkedIn}
            otherClasses={!isSyncing && hasLinkedIn ? styles.linkedinButton : null}
          >
            {isSyncing ? 'Fetching...' : 'Fetch from LinkedIn'}
          </Button>
        </Tooltip>
      )}
    </>
  );
};

export default Links;
